export const INPUT = 'input';
export const RADIO_LIST = 'radioList';
export const ZIP = 'zip';
export const BINARY = 'binary';
export const DEFAULT_QUESTION = 'default';
